import axios, {type InternalAxiosRequestConfig} from 'axios'

export const cookieName = "CF_Authorization";
export const currentAuthToken = () => {
    return (document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName +"="))
        ?.split("=")[1]) ?? "";
}

function getSessionId(): string {
  let id = sessionStorage.getItem('planner_session_id')
  if (!id) {
    id = crypto.randomUUID()
    sessionStorage.setItem('planner_session_id', id)
  }
  return id
}

export const api = axios.create({
    baseURL: import.meta.env.VITE_DATA_API || "http://localhost:3000",
    headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
    },
    validateStatus: (status) => {
      return status < 400;
    }
})

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  config.headers['X-CF-Authorization'] = `Bearer ${currentAuthToken()}`

  const sessionId = getSessionId()
  if (['get', 'head', 'options'].includes(config.method ?? '')) {
    config.params = { ...config.params, sessionId }
  } else if (config.data instanceof FormData) {
    config.data.append('sessionId', sessionId)
  } else if (config.data && typeof config.data === 'object') {
    config.data = { ...config.data, sessionId: sessionId }
  } else {
    config.data = { sessionId }
  }

  return config;
})
